<template>
  <Grid
    id="documentGrid"
    class="fit"
    :module="module"
    :data="documentList"
    :pagination="pagination"
    :columns="columnOptions"
    :loading="loadingData"
    :onDownload="select"
    :shouldShowRead="isKennyHuangOrAdmin ? shouldShowRead : () => false"
    :onRead="read"
    :onRequest="onFetch"
    :filterable="filterable"
    :onDelete="onRemove"
  />
</template>

<script>
import Grid from '../Shared/Grid'
import { mapActions, mapState, mapGetters, mapMutations, } from 'vuex'

const KENNY_HUANG_USER_IDS = [702, 705, 1915, 2270]

export default {
  name: 'DocumentGrid',
  components: {
    Grid
  },
  props: {
    entityItemId: {},
    entityItemIds: Array,
    count: {},
    documentTypeId: {},
    pagination: {},
    deletable: {
      Type: Boolean,
      default: false
    }
  },
  created () {
    let vm = this
    if(!vm.deletable){
      vm.onRemove = undefined
    }
  },
  data () {
    return {
      filterable: true,
      module: this.$route.meta.module,
      visibleColumns: ['DATE_CREATED', 'DOCUMENT_NAME', 'DOCUMENT_TYPE', 'FILE_TYPE'],
      columnOptions: [
        // { field: 'LK_ENTITY_ID', name: 'LK_ENTITY_ID', label: 'Entity', sortable: true, filterable: true, filter: null, type: 'id' },
        { field: 'DATE_CREATED', name: 'DATE_CREATED', label: 'Upload Date', sortable: true
        // filterable: true, filter: '', type: 'date'
        },
        { field: 'DOCUMENT_NAME', name: 'DOCUMENT_NAME', label: 'Document Name', sortable: false
        // filterable: true, filter: null, type: 'string'
        },
        { field: 'DOCUMENT_TYPE', name: 'DOCUMENT_TYPE', label: 'Label', sortable: true,
          format: r => { return r ? r.DOCUMENT_TYPE : null }
        // filterable: true, filter: null, type: 'string' 
        },
        { field: 'FILE_TYPE', name: 'FILE_TYPE', label: 'Type', sortable: true,
          format: r => { return r ? r.FILE_EXTENSION : null }
        }
      ],
      readingStep: 1,
    }
  },
  computed: {
    ...mapState('documents', {
      loadingData: state => state.loadingData,
      uploadForm: state => state.uploadForm,
      readingRoster: state => state.readingRoster,
    }),
    ...mapState('classes', {
      sessionInformation: state => state.sessionInformation,
    }),
    ...mapGetters('documents', [
      'documentList'
    ]),
    isKennyHuangOrAdmin() {
      // TODO remove this block after auto-roster 2.0
      if (this.$p(['AFFILIATE'])) {
        if (KENNY_HUANG_USER_IDS.includes(this.currentUser().USER_ID)) {
          return true
        }
      }

      return this.$p(['ADMIN'])
    },
  },
  methods: {
    ...mapActions('documents', [
      'openUploadModal',
      'getPreSignedUrl',
      'fetch',
      'select',
      'remove',
      'readRoster',
    ]),
    ...mapMutations('documents', [
      'setReadingRoster',
    ]),
    onFetch (options) {
      options.customFilter = []
      if (this.module === 'users' || this.module === 'instructorApprovals') { 
        options.customFilter = [{ field: 'LK_ENTITY_ID', filter: '1' }]
      } else if (this.module === 'students') {
        options.customFilter = [{ field: 'LK_ENTITY_ID', filter: '2' }]
      } else if (this.module === 'courses') {
        options.customFilter = [{ field: 'LK_ENTITY_ID', filter: '3' }]
      } else if (this.module === 'classes') {
        options.customFilter = [{ field: 'LK_ENTITY_ID', filter: '4' }]
      } else if (this.module === 'orders') {
        options.customFilter = [{ field: 'LK_ENTITY_ID', filter: '6' }]
      }
      
      if (this.entityItemId) options.customFilter.push({ field: 'ENTITY_ITEM_ID', filter: this.entityItemId })
      if (this.documentTypeId) options.customFilter.push({ field: 'LK_DOCUMENT_TYPE_ID', filter: this.documentTypeId })
      if (this.entityItemIds) options.customFilter.push({ field: 'ENTITY_ITEM_ID', filter: this.entityItemIds })

      if (this.entityItemId && this.documentTypeId) return this.fetch(options)
      return this.fetch(options)
    },
    onRemove (payload) {
      let vm = this
      const { DOCUMENT_ID, ENTITY_ITEM_ID } = payload

      const customFilter = []
      if (vm.module === 'users' || vm.module === 'instructorApprovals') { 
        customFilter.push({ field: 'LK_ENTITY_ID', filter: '1' })
      } else if (vm.module === 'students') {
        customFilter.push({ field: 'LK_ENTITY_ID', filter: '2' })
      } else if (vm.module === 'courses') {
        customFilter.push({ field: 'LK_ENTITY_ID', filter: '3' })
      } else if (vm.module === 'classes') {
        customFilter.push({ field: 'LK_ENTITY_ID', filter: '4' })
      }

      if (vm.module != 'documents') {
        customFilter.push({ field: 'ENTITY_ITEM_ID', filter: ENTITY_ITEM_ID })
      }

      return new Promise(function (resolve, reject) {
        vm.remove(DOCUMENT_ID, 'utf8').then(function (res) {
          // return vm.fetch({ customFilter: customFilter })
          setTimeout(function () {
            vm.$root.$emit("refreshGrid:documentGrid")
          }, 0)
        }, reject)
      })
    },
    shouldShowRead(doc) {
      const ROSTER = 1, STUDENT_INFO = 20
      return [ROSTER, STUDENT_INFO].includes(doc.LK_DOCUMENT_TYPE_ID)
    },
    async read(doc) {
      if (this.readingRoster) {
        return
      }

      this.setReadingRoster(true)
      try {
        const rosterJobId = await this.readRoster({
          key: doc.DOCUMENT_S3_KEY,
          document_id: doc.DOCUMENT_ID,
          class_id: this.sessionInformation.classId
        })
        if (rosterJobId) {
          this.$q.notify({
            message: `This document already has a roster job: ${rosterJobId}`,
            type: 'negative'
          })
        } else {
          this.$q.notify({
            message: 'Your document is being processed',
            type: 'positive'
          })
        }
      } catch (err) {
        this.$q.notify({
          message: `Error reading document: ${err}`,
          type: 'negative'
        })
      } finally {
        this.setReadingRoster(false)
      }
    },
  },
  watch: {
  }
}
</script>

<style>
</style>
